import { useNavigate } from "react-router-dom";
import CatService from "../../../service/CatService";
import DataGrid from "../../common/DataGrid";
import { useEffect, useState } from "react";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Button } from "primereact/button";
import { Panel } from "primereact/panel";
import { Card } from "primereact/card";
import { TabPanel, TabView } from "primereact/tabview";
import { useTranslation } from "react-i18next";

export function WrkPage(){
    let nav = useNavigate();
    const {t}=useTranslation();
    const [reload,setReload]=useState(false);
    const [wrks,setWrks]=useState([]);
    const [wrksTaken,setWrksTaken]=useState([]);

    const loadRecords=()=>{
        CatService.getWrks().then((recs)=>{
            var w=recs.filter((wrk)=>wrk.wrkActId==null);
            var wt=recs.filter((wrk)=>wrk.wrkActId!=null);
            setWrks(w);
            setWrksTaken(wt);
            setReload(false);
        })
    }
    useEffect(()=>{
        loadRecords();
    },[]);

    return(
        <div className="col-12">
            <Card>
                <TabView>
                <TabPanel header={t('Works available')+' (' + wrks.length+')'}>
                    <WrkGrid wrks={wrks}/>
                </TabPanel>
                <TabPanel header={t('Works not completed')+' (' + wrksTaken.length+')'}>
                    <WrkGrid wrks={wrksTaken}/>
                </TabPanel>
                </TabView>
            </Card>
        </div>
    )
}
export function WrkGrid({wrks}){
    let nav = useNavigate();
    const {t}=useTranslation();
    const [reload,setReload]=useState(false);
    const [selectedWrks,setSelectedWrks]=useState([]);

    const contextMenuItems=[
            {label: t('Open'), icon: 'pi pi-sign-in', actionName: 'open'}
		 ];
    const openWorkPage=(wrk)=>{
        if(wrk.workType == 'QUE_APP_ADD'||wrk.workType == 'QUE_APP_UP'||wrk.workType == 'QUE_REV_ADD'||wrk.workType == 'QUE_REV_UP')
            nav('/itembank/question/'+wrk.objId+'/review',{state: wrk});
        else if(wrk.workType == 'QUE_UPDATE')
            nav('/itembank/question/'+wrk.objId,{state: wrk});
    }
    const openWork=(wrk)=>{
        if(wrk.wrkActId == null)
        {
            CatService.chkinWrk(wrk.id).then((ret)=>{
                openWorkPage(wrk);
            }).catch(err=>{
                console.log(err);
            });
        }
        else
            openWorkPage(wrk);        
    }
    const actionBodyTemplate=(rowData)=>{
        var menu = contextMenuItems.map((item)=>{
            return <Button size="small" severity="secondary" icon={item.icon} label={item.label} onClick={()=>contextAction(item.actionName,rowData)}/>
        });
        return <div className='flex gap-1'>{menu}</div>;
    }
    const contextAction=(action,rec)=>{
		if(action == 'open')
            openWork(rec);
    }	         
    return(
        <>
            <DataTable value={wrks} contextMenuItems={contextMenuItems} contextAction={contextAction}> 
                <Column header={t("Id")} field="id" style={{width:'5%'}} sortable/>
                <Column header={t("Object Id")} field="objId" style={{width:'5%'}} sortable/>
                <Column header={t("Object Type")} field="objType" style={{width:'10%'}} sortable
                    body={(wrk)=>{return t('entity.'+wrk.objType)}}/>
                <Column header={t("Path")} field="path" style={{width:'20%'}} sortable/>
                <Column header={t("Work Type")} field="workType" style={{width:'50%'}} sortable
                    body={(wrk)=>{return t('WorkType.'+wrk.workType)}}
                    />
                <Column header={t("Creation Date")} field='created' style={{width:'20%',whiteSpace:'nowrap'}} sortable
                    body={(wrk)=>{return t('datetime.short',{val:wrk.created})}}
                    />
                <Column header="" style={{width:'10%'}} body={actionBodyTemplate}/>
            </DataTable>
        </>
    )
}
export default WrkPage;